import { QRFC } from "./QRFC";

export class QGetReportHistoryRFC extends QRFC {
  constructor() {
    super();
  }

  InitReportIssue(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  SetParams(org, user) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
  }

  GetCallName() {
    return "qgetreportlogs";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    if (r["success"]) callBackObj.fWSMgr.DownloadPub(r["filename"]);
  }
}
